import React from "react"
import { useTranslation } from "react-i18next"

import {
  calculateItemSalePrice,
  calculateTotalTaxes,
  roundNumber,
  thousandSeparator
} from "utils"
import OhTaxes from "./OhTaxes"
import classes from "./index.module.scss"

const OhFooter = props => {
  const { order } = props

  const {
    items,
    deliveryFee,
    deliveryType,
    deliveryDiscount = 0,
    foodDiscount = 0
  } = order

  const [t] = useTranslation()

  const totalSpecificationItems =
    items.reduce((to, item) =>
      to += item.totalSpecificationSalePrice, 0
    )

  const subtotal =
    totalSpecificationItems +
    items.reduce((t, item) => (
      t += calculateItemSalePrice(item) * item.quantity
    ), 0)

  const isShipping = deliveryType === "delivery"

  const totalSystemDiscounts =
    items.reduce((t, item) => (
      t += (item.systemDiscount > 0 ? item.systemDiscount : 0)
    ), 0)

  const totalDiscount =
    totalSystemDiscounts +
    deliveryDiscount +
    foodDiscount

  const totalTax = calculateTotalTaxes(order)

  const totalBeforeRounding =
    subtotal +
    totalTax +
    deliveryFee -
    totalDiscount

  const total =
    roundNumber(
      totalBeforeRounding
    )

  return (
    <div className={classes["container"]}>
      <div className={classes["total-item"]}>
        <span>{t("مجموع_اقلام")}</span>
        <span>{thousandSeparator(subtotal)}</span>
      </div>
      {
        isShipping &&
        <div className={classes["delivery-fee-container"]}>
          <div className={classes["delivery-fee"]}>
            <span>{t("هزینه_ی_ارسال")}</span>
            <span>{thousandSeparator(deliveryFee)}</span>
          </div>
        </div>
      }
      {
        foodDiscount > 0 &&
        <div className={classes["discount"]}>
          <span>{t("تخفیف_کالا")}</span>
          <span>{thousandSeparator(-foodDiscount)}</span>
        </div>
      }
      {
        deliveryDiscount > 0 &&
        <div className={classes["discount"]}>
          <span>{t("تخفیف_ارسال")}</span>
          <span>{thousandSeparator(-deliveryDiscount)}</span>
        </div>
      }
      {
        totalSystemDiscounts > 0 &&
        <div className={classes["discount"]}>
          <span>{t("تخفیف_صندوق_دار")}</span>
          <span>{thousandSeparator(-totalSystemDiscounts)}</span>
        </div>
      }
      <OhTaxes order={order} />
      <div className={classes["total"]}>
        <span>{t("مجموع")}</span>
        <span>
          {thousandSeparator(total)}
        </span>
      </div>
    </div>
  )
}

export default OhFooter